import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PPMetricsCards from "../payrole-tabs/PPMetricsCards";
import DiscrepancyManagementTable from "../payrole-tabs/DiscrepancyManagementTable";
import { fetchStaffPayroleDiscrepancyData } from "../../../redux/payrole-reducers/payroleSlice";
import CmnFilters from "../../lead-management/common/CmnFilters";

const Discrepancies = ({ userInfoData }) => {
  const dispatch = useDispatch();
  const {
    staffPayroleDiscrepancyData,
    staffPayroleDiscrepancyLoading,
    staffPayroleDiscrepancyError,
  } = useSelector((state) => state.payrole);

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";
  const isManagerRole = ["fitness_manager", "sales_manager", "club_manager"].includes(userInfoData?.account_type);
  const isStaff =
    userInfoData?.account_type === "receptionist" ||
    userInfoData?.account_type === "trainer";

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym: !isAdmin && !isClusterManager && !isManagerRole
      ? {
          label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
          value:
            userInfoData?.gym_id ||
            userInfoData?.user_id ||
            userInfoData?.uid ||
            "",
        }
      : "",
    accountType: "",
    selectedMonth: "",
    isActive: "",
    leadAddDateFrom: "",
    leadAddDateTo: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    user_id: isStaff ? userInfoData?.user_id || userInfoData?.uid || "" : "",
    month: allFilters.selectedMonth?.value || "",
    status: "pending",
    date_from: allFilters.leadAddDateFrom || "",
    date_to: allFilters.leadAddDateTo || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const [statsData, setStatsData] = useState({});

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
  };

  const onClickSearch = () => {
    setIsPage(0);
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  const getPayroleDiscrepancy = (filters) => {
    dispatch(
      fetchStaffPayroleDiscrepancyData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  useEffect(() => {
    setAllFilters((prevs) => ({
      ...prevs,
      selectedGym: !isAdmin && !isClusterManager && !isManagerRole
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    }));
  }, [userInfoData?.gym_id]);

  useEffect(() => {
    getPayroleDiscrepancy(filters);
  }, [filters]);

  useEffect(() => {
    if (
      !staffPayroleDiscrepancyLoading &&
      !staffPayroleDiscrepancyError &&
      staffPayroleDiscrepancyData?.status &&
      staffPayroleDiscrepancyData?.stats
    ) {
      const { open_issue, resolved, resolve_percent } =
        staffPayroleDiscrepancyData.stats || {};

      setStatsData({ open_issue, resolved, resolve_percent });
    } else {
      setStatsData({});
    }
  }, [
    staffPayroleDiscrepancyLoading,
    staffPayroleDiscrepancyError,
    staffPayroleDiscrepancyData,
  ]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: allFilters.selectedGym?.value || "",
      account_type: allFilters.accountType?.value || "",
      month: allFilters.selectedMonth?.value || "",
      date_from: allFilters.leadAddDateFrom || "",
      date_to: allFilters.leadAddDateTo || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.accountType,
    allFilters.selectedMonth,
    allFilters.leadAddDateFrom,
    allFilters.leadAddDateTo,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <div className="pp-wrapper pp-discrepancies-container">
      <CmnFilters
        from={"payrole-processor-logs"}
        clickedCard="discrepancies"
        userInfoData={userInfoData}
        onClickReset={onResetFilters}
        filters={allFilters}
        setFilters={setAllFilters}
        onClickSearch={onClickSearch}
        searchFilterApplied={searchFilterApplied}
        searchPlaceHolder="Search by staff name, mobile, email..."
        isLoading={staffPayroleDiscrepancyLoading}
      />
      <br />

      <PPMetricsCards metrics={statsData} />

      <DiscrepancyManagementTable
        userInfoData={userInfoData}
        callFunction={() => getPayroleDiscrepancy(filters)}
        isPage={isPage}
        setIsPage={setIsPage}
        pageLimit={pageLimit}
        setPageLimit={setPageLimit}
        setFilters={setFilters}
        filters={filters}
      />
    </div>
  );
};

export default Discrepancies;
